// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_boost__current__enlZ1 {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
}
.style_boost__current__left__l2Tg2 {
  flex: 3 1;
  display: flex;
  gap: 8px;
  align-items: center;
}
.style_boost__current__image__-1erw {
  width: 50px;
  height: 50px;
}
.style_boost__current__title__aL1nd {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.style_boost__current__name__d7QGL {
  color: rgb(27, 27, 27);
  font-size: 1.8rem;
  font-weight: bold;
}
.style_boost__current__item__Z7CMM {
  display: flex;
  gap: 5px;
}
.style_boost__current__icon__8hp8q {
  font-size: 1.4rem;
  color: rgb(27, 27, 27);
}
.style_boost__current__title__text__st-c1 {
  font-size: 1.4rem;
  color: rgb(27, 27, 27);
}
.style_boost__current__level__\\+bl1z {
  flex: 1 1;
  font-size: 1.4rem;
  color: rgb(135, 135, 135);
  display: flex;
  justify-content: flex-end;
}

.style_boost__final__KigyB {
  background: rgb(117, 83, 240);
}
.style_boost__final__name__y2ck4, .style_boost__final__icon__CE20U, .style_boost__final__title__text__IOuRt, .style_boost__final__level__hna26 {
  color: #efedf9 !important;
}
.style_boost__final__title__name__GzB-B {
  color: rgb(255, 255, 255) !important;
  font-size: 1.8rem;
  font-weight: bold;
}
.style_boost__final__title__item__icon__6M64h {
  color: rgb(255, 255, 255) !important;
}
.style_boost__final__title__item__title__text__tPu49 {
  color: rgb(255, 255, 255) !important;
}
.style_boost__final__level__hna26 {
  color: #efedf9 !important;
}`, "",{"version":3,"sources":["webpack://./src/features/boosts/components/boost-item/boost-item-current/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AADF;AAGE;EACE,SAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHJ;AAME;EACE,sBCxBU;EDyBV,iBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,QAAA;AALJ;AAQE;EACE,iBAAA;EACA,sBCpCU;AD8Bd;AASE;EACE,iBAAA;EACA,sBCzCU;ADkCd;AAUE;EACE,SAAA;EACA,iBAAA;EACA,yBC9CQ;ED+CR,aAAA;EACA,yBAAA;AARJ;;AAYA;EACE,6BCxDK;AD+CP;AAWE;EAIE,yBAAA;AAZJ;AAgBI;EACE,oCAAA;EACA,iBAAA;EACA,iBAAA;AAdN;AAkBM;EACE,oCAAA;AAhBR;AAmBM;EACE,oCAAA;AAjBR;AAsBE;EACE,yBAAA;AApBJ","sourcesContent":["@import '../../../../../../public/assets/colors';\n\n.boost__current {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 8px;\n\n  &__left {\n    flex: 3;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n\n  &__image {\n    width: 50px;\n    height: 50px;\n  }\n\n  &__title {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  &__name {\n    color: $black-extra;\n    font-size: 1.8rem;\n    font-weight: bold;\n  }\n\n  &__item {\n    display: flex;\n    gap: 5px;\n  }\n\n  &__icon {\n    font-size: 1.4rem;\n    color: $black-extra;\n  }\n\n  &__title__text {\n    font-size: 1.4rem;\n    color: $black-extra;\n  }\n\n  &__level {\n    flex: 1;\n    font-size: 1.4rem;\n    color: $dark-grey;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.boost__final {\n  background: $main;\n\n  &__name,\n  &__icon,\n  &__title__text,\n  &__level {\n    color: #efedf9 !important;\n  }\n\n  &__title {\n    &__name {\n      color: $white !important;\n      font-size: 1.8rem;\n      font-weight: bold;\n    }\n\n    &__item {\n      &__icon {\n        color: $white !important;\n      }\n\n      &__title__text {\n        color: $white !important;\n      }\n    }\n  }\n\n  &__level {\n    color: #efedf9 !important;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boost__current": `style_boost__current__enlZ1`,
	"boost__current__left": `style_boost__current__left__l2Tg2`,
	"boost__current__image": `style_boost__current__image__-1erw`,
	"boost__current__title": `style_boost__current__title__aL1nd`,
	"boost__current__name": `style_boost__current__name__d7QGL`,
	"boost__current__item": `style_boost__current__item__Z7CMM`,
	"boost__current__icon": `style_boost__current__icon__8hp8q`,
	"boost__current__title__text": `style_boost__current__title__text__st-c1`,
	"boost__current__level": `style_boost__current__level__+bl1z`,
	"boost__final": `style_boost__final__KigyB`,
	"boost__final__name": `style_boost__final__name__y2ck4`,
	"boost__final__icon": `style_boost__final__icon__CE20U`,
	"boost__final__title__text": `style_boost__final__title__text__IOuRt`,
	"boost__final__level": `style_boost__final__level__hna26`,
	"boost__final__title__name": `style_boost__final__title__name__GzB-B`,
	"boost__final__title__item__icon": `style_boost__final__title__item__icon__6M64h`,
	"boost__final__title__item__title__text": `style_boost__final__title__item__title__text__tPu49`
};
export default ___CSS_LOADER_EXPORT___;
